import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Clock3 } from "lucide-react";

const ZONES = [
  { label: "USA", city: "New York", tz: "America/New_York", flag: "🇺🇸" },
  { label: "UK", city: "London", tz: "Europe/London", flag: "🇬🇧" },
  { label: "Nigeria", city: "Lagos", tz: "Africa/Lagos", flag: "🇳🇬" },
];

function fmt(tz, now) {
  const time = new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }).format(now);
  const day = new Intl.DateTimeFormat("en-GB", { timeZone: tz, weekday: "short", day: "numeric", month: "short" }).format(now);
  const hour = Number(new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "numeric", hour12: false }).format(now));
  return { time, day, night: hour < 6 || hour >= 19 };
}

export default function WorldClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="world-clock">
      {ZONES.map((z) => {
        const f = fmt(z.tz, now);
        return (
          <Card key={z.label} className="gold-ring glass relative overflow-hidden p-4" data-testid={`clock-${z.label}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-xl">{z.flag}</span>
                <div><p className="text-sm font-700">{z.label}</p><p className="text-[0.65rem] uppercase tracking-wider text-muted-foreground">{z.city}</p></div>
              </div>
              <Clock3 className={`h-4 w-4 ${f.night ? "text-indigo-400" : "text-[hsl(var(--gold))]"}`} />
            </div>
            <p className="font-mono-data mt-3 text-3xl font-700 tabular-nums tracking-tight" data-testid={`clock-time-${z.label}`}>{f.time}</p>
            <p className="text-xs text-muted-foreground">{f.day} · {f.night ? "Night" : "Day"}</p>
          </Card>
        );
      })}
    </div>
  );
}
